/**
 * Идентификатор вкладки для realtime: REST-запросы несут его в `x-sloy-client`,
 * сервер эхом кладёт в data-события — вкладка-автор пропускает свои события
 * (у неё уже применён оптимистичный патч + ответ мутации).
 *
 * Живёт в памяти модуля: новая вкладка = новый id, что и требуется.
 */
export const realtimeClientId: string =
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `tab-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
